import { formatError } from '../utils/errorUtils';
import { ErrorService } from './errorService';
import coreApi from '../api/coreApi';
import { authService } from './authService';

export interface Verse {
  book: string;
  chapter: string;
  verse: string;
  text?: string;
  error?: boolean;
}

export interface BookInfo {
  number: string;
  name: string;
}

class BibleService {
  async getBookInfo(book: string): Promise<BookInfo> {
    try {
      const response = await coreApi.get(`/bible/books/${book}`);
      return response.data;
    } catch (error) {
      ErrorService.handle(error, {
        severity: 'low',
        userMessage: 'Unable to get book information',
        context: { book }
      });
      throw error;
    }
  }

  async getChapterCount(book: string): Promise<number> {
    try {
      const response = await coreApi.get(`/bible/chapter-count/${book}`);
      return response.data.count;
    } catch (error) {
      ErrorService.handle(error, {
        severity: 'low',
        userMessage: 'Unable to get chapter count',
        context: { book }
      });
      return 0;
    }
  }

  async getVerses(book: string, chapter: string, startVerse?: string, endVerse?: string): Promise<Verse[]> {
    try {
      let url = `/bible/verses/${book}/${chapter}`;
      if (startVerse) {
        url += `/${startVerse}${endVerse ? `/${endVerse}` : ''}`;
      }
      const response = await coreApi.get(url);
      return response.data;
    } catch (error) {
      ErrorService.handle(error, {
        severity: 'low',
        userMessage: 'Unable to get verses',
        context: { book, chapter, startVerse, endVerse }
      });
      return [];
    }
  }

  async isVerseBookmarked(book: string, chapter: string, verse: string): Promise<boolean> {
    if (!authService.isAuthenticated()) return false;
    try {
      const response = await coreApi.get(`/bible/bookmarks/${book}/${chapter}/${verse}`);
      return response.data.bookmarked;
    } catch (error) {
      return false;
    }
  }
}

// Export a singleton instance
export const bibleService = new BibleService();